export default __webpack_public_path__ + "static/media/516.14c631e5.png";